import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
//import createOidcMiddleware, { createUserManager, loadUser } from 'redux-oidc';
import { createUserManager, loadUser } from 'redux-oidc';
import userManager from './utils/userManager';
import rootReducer from './reducers';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import initialState from './reducers/initialState';

// create the middleware with the userManager
//const oidcMiddleware = createOidcMiddleware(userManager, () => true, false, '/callback');
//oidcMiddleware

const createStoreWithMiddleware = compose(
  applyMiddleware(thunk, reduxImmutableStateInvariant())
)(createStore);

const store = createStoreWithMiddleware(rootReducer, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

loadUser(store, userManager);

export default store;
